import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as widgetConfigActions from '../actions/widget-configs';
import { WidgetConfigurationsService } from '../services/widget-configurations.service';
import { WidgetConfiguration } from '../models/widget-configuration';

@Injectable()
export class WidgetConfigurationEffects {

  constructor(
    private actions$: Actions,
    private widgetConfigurationsService: WidgetConfigurationsService) {
  }

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<widgetConfigActions.Load>(widgetConfigActions.LOAD),
    switchMap((action) => {
      return this.widgetConfigurationsService.getForDashboard(action.dashboardIdentifier)
        .pipe(
          map((configs: WidgetConfiguration[]) => new widgetConfigActions.LoadComplete(configs)),
          catchError(err => of(new widgetConfigActions.LoadError(err)))
        );
    })));

  
  loadByProfile$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<widgetConfigActions.LoadByProfile>(widgetConfigActions.LOAD_BY_PROFILE),
    switchMap((action) => {
      return this.widgetConfigurationsService.getAllForDashboardAndProfile(action.dashboardIdentifier, action.profileId)
        .pipe(
          map((configs: WidgetConfiguration[]) => new widgetConfigActions.LoadComplete(configs)),
          catchError(err => of(new widgetConfigActions.LoadError(err)))
        );
    })));

  
  loadAll$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<widgetConfigActions.LoadAll>(widgetConfigActions.LOAD_ALL),
    switchMap((action) => {
      return this.widgetConfigurationsService.getAll(action.product)
        .pipe(
          map((configs: WidgetConfiguration[]) => new widgetConfigActions.LoadComplete(configs)),
          catchError(err => of(new widgetConfigActions.LoadError(err)))
        );
    })));

}
